import { useMutation } from 'react-query';
import { Users } from '~/api/scheme';
import useCurrentUser from '~/hooks/useCurrentUser';

type Result = {
  masqueradeBack: () => void;
  fullname: string;
};

const useMasqueradeBack = (): Result => {
  const { currentUser } = useCurrentUser();
  const fullname = `${currentUser?.attributes.first_name} ${currentUser?.attributes.last_name}`;

  const mutation = useMutation(() => Users.Masquerade.masqueradeBack(), {
    onSuccess() {
      window.location.reload();
    },
  });

  const masqueradeBack = () => {
    mutation.mutate();
  };

  return {
    masqueradeBack,
    fullname,
  };
};

export default useMasqueradeBack;
